import React from 'react';
import { Icon } from '@iconify/react';
import { AppButton, AppButtonLink } from '../../components/AppButton/AppButton';
import { getPlanFeatures } from './pricingPlans';
import './Pricing.css';

/**
 * props:
 * - plan
 * - currentPlanId
 * - disabled
 * - purchaseLabel
 * - onSelect
 * - checkoutWrapper (optional render prop for StripeCheckout)
 */
function PricingCard({
    plan,
    currentPlanId = null,
    disabled = false,
    purchaseLabel,
    onSelect,
    checkoutWrapper,
}) {
    const isCurrent = currentPlanId === plan.limitId;
    const isActivated = disabled && isCurrent;
    const features = getPlanFeatures(plan);
    const label = purchaseLabel || (isCurrent ? 'Current plan' : plan.cta);

    const cardClassName = [
        'pricing-card',
        plan.highlighted ? 'pricing-card--highlighted' : '',
        isCurrent ? 'pricing-card--current' : '',
        disabled && !isCurrent ? 'pricing-card--disabled' : '',
    ].filter(Boolean).join(' ');

    const ctaVariant = plan.highlighted ? 'primary' : 'secondary';

    const ctaButton = plan.price === 0 ? (
        <AppButtonLink to={plan.ctaTo} variant="secondary" size="md" fullWidth>
            {label}
        </AppButtonLink>
    ) : onSelect || checkoutWrapper ? (
        <AppButton
            type="button"
            variant={ctaVariant}
            size="md"
            fullWidth
            disabled={isActivated || disabled}
            onClick={onSelect}
        >
            {label}
        </AppButton>
    ) : (
        <AppButtonLink to={plan.ctaTo} variant={ctaVariant} size="md" fullWidth>
            {label}
        </AppButtonLink>
    );

    const wrappedCta = checkoutWrapper ? checkoutWrapper(ctaButton) : ctaButton;

    return (
        <article className={cardClassName}>
            {plan.highlighted && !isCurrent && (
                <span className="pricing-card-badge">Most popular</span>
            )}
            {isCurrent && (
                <span className="pricing-card-badge pricing-card-badge--current">Current plan</span>
            )}

            <div className="pricing-card-top">
                <span className="pricing-card-icon" aria-hidden="true">
                    <Icon icon={plan.icon} />
                </span>
                <h2 className="pricing-card-name">{plan.name}</h2>
            </div>

            <p className="pricing-card-description">{plan.description}</p>

            <div className="pricing-card-price-row">
                <span className="pricing-card-currency">$</span>
                <span className="pricing-card-price">{plan.price}</span>
                <span className="pricing-card-period">/month</span>
            </div>

            <ul className="pricing-card-features">
                {features.map((feature) => (
                    <li key={feature} className="pricing-card-feature">
                        <Icon icon="mdi:check-circle" className="pricing-card-feature-icon" aria-hidden="true" />
                        <span>{feature}</span>
                    </li>
                ))}
            </ul>

            <div className="pricing-card-cta">
                {wrappedCta}
            </div>
        </article>
    );
}

export default PricingCard;